import { render, staticRenderFns } from "./DsnTableColumn.vue?vue&type=template&id=78c59e70&"
import script from "./DsnTableColumn.vue?vue&type=script&lang=js&"
export * from "./DsnTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports